import { Input } from "@/components/Inputs";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Link } from "react-router-dom";

const Index = ({ data }) => {
    const [email, setEmail] = useState("");
    console.log(data)
    return (
        <div className="pb-6 md:pb-20 flex flex-col-reverse md:flex-row items-start padding-x">
            <section className="w-full md:w-2/3 md:mr-5">
                <h1 className="font-bold text-xl md:text-2xl lg:text-3xl">Thank you!</h1>
                <p className="pb-4 font-light text-sm">We’ve got your order.</p>
                <div className="flex flex-col p-2 rounded-lg bg-white">
                    {/* <p className="w-full p-2 pb-0 text-sm">Order #{data.orderNumber}</p> */}
                    <p className="text-shade-dark p-2 pt-1 pb-0 text-sm font-light flex items-center">
                        {/* <CheckCircleIcon className="w-4 h-4 mr-1" /> Paid £{parseFloat(data.totalprice).toFixed(2)} */}
                    </p>
                    <p className="text-shade-dark p-2 pt-0 text-sm font-light flex items-center">
                        <CheckCircleIcon className="w-4 h-4 mr-1" /> Ready to go
                    </p>
                    <div className="p-2 py-4">
                        <div className="flex w-full text-sm font-light">
                            <div className="flex-1 p-2 px-4 rounded-l cursor-pointer text-white bg-shade-dark">
                                Eat in
                            </div>
                            <div className="flex-1 p-2 px-4 rounded-r cursor-pointer bg-shade">Table 1</div>
                        </div>
                    </div>
                </div>
                <br />
                <div className="flex flex-wrap p-2 rounded-lg bg-white">
                    <p className="w-full p-2">Receipt</p>
                    <div className="flex items-center rounded border-l-4 cursor-pointer p-2 m-2 w-full border-primary bg-shade-light ">
                        <p className="text-sm font-light">Email</p>
                    </div>
                    <div className="flex w-full pr-2">
                        <Input
                            width="w-3/4"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="text"
                            placeholder="Email address"
                        />
                        <button className="w-1/4 bg-secondary text-white rounded p-3 my-2 font-semibold text-center">
                            Send
                        </button>
                    </div>
                    <div className="flex items-center rounded border-l-4 cursor-pointer p-2 m-2 w-full bg-shade-light ">
                        <p className="text-sm font-light">SMS</p>
                    </div>
                </div>
                <div className="flex flex-col">
                    <Link
                        to="/dashboard/orders"
                        className="bg-primary hover:bg-secondary text-white rounded-lg p-2 px-6 my-4 w-full md:w-fit m-auto font-semibold text-center"
                    >
                        View my order
                    </Link>
                    <Link
                        className="text-primary hover:text-secondary rounded-lg w-fit m-auto font-semibold text-center"
                        to={"/menu"}
                    >
                        Back to menu
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Index;
